import { useMediaQuery } from '@mantine/hooks'
import ActionButton from 'components/CourseInfo/ActionButton'
import KlassInfoHeader from 'components/CourseInfo/KlassInfoHeader'
import HTMLRender from 'components/DetailRender/HTMLRender'
import dayjs from 'dayjs'
import isBetween from 'dayjs/plugin/isBetween'
import { useRouter } from 'next/router'
import WithHeader from 'shared/layout/WithHeader'
import { ICourse } from 'stores/courses'

import styles from '../../../../pages/event/[eventId]/eventDetail.module.scss'

dayjs.extend(isBetween)

interface IEOEvent {
  course: ICourse
}

const EOEvent = ({ course }: IEOEvent) => {
  const { applyStartedAt, applyEndedAt, flags } = course
  const router = useRouter()
  const isMobile = useMediaQuery('max-width:1023px')
  const url = flags?.find(item => item.startsWith('url:'))?.replace('url:', '')

  const isApplyPeriod = dayjs().isBetween(
    dayjs(applyStartedAt, 'YYYY-MM-DDTHH:mm:ss.000ZZ').format(),
    dayjs(applyEndedAt, 'YYYY-MM-DDTHH:mm:ss.000ZZ').format(),
  )

  return (
    <WithHeader>
      <main style={{ minWidth: 360, marginBottom: 220 }}>
        <div className="mt-5 max-w-7xl lg:mt-6 lg:px-4 xl:mx-auto xl:px-6">
          <div className="lg:flex lg:flex-row-reverse lg:items-start">
            <aside
              className={`${styles.rightPanel} mb-6 h-auto lg:sticky lg:right-0 lg:mb-0 lg:shrink-0`}>
              <div className="px-4 lg:rounded-lg lg:border lg:border-gray-300 lg:p-6 lg:pt-5">
                <KlassInfoHeader
                  isMobile={isMobile}
                  klassId={course.id}
                  title={course.title}
                  panelText={course.panelText}
                  shareUrl={course.shareUrl}
                  imgUrl={course.imageM}
                />
                <hr className="mb-4 w-full border-gray-300 lg:hidden" />
                <div className="fixed bottom-0 left-0 right-0 z-20 whitespace-nowrap border border-t bg-white px-4 pb-4 lg:static lg:border-none lg:px-0 lg:pb-0">
                  <ActionButton
                    course={course}
                    klassId={course.id}
                    disabled={!isApplyPeriod}
                    handler={() => router.push(url as string)}
                    name={'선착순 | 이벤트 참여하기'}
                  />
                </div>
              </div>
            </aside>
            <div className="lg:mr-6">
              <hr className="h-3 w-full border-none bg-gray-100 lg:hidden" />
              <div className="px-4 pb-20 pt-4 lg:p-0">
                <HTMLRender html={course.description} />
              </div>
            </div>
          </div>
        </div>
      </main>
    </WithHeader>
  )
}

export default EOEvent
